<div class="main-content table-page carga-excel-bsc">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Cargar Excel FOR-011</h1>
        <p>El sistema lee el archivo y muestra qué haría. Nada se guarda hasta confirmar.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <ol class="carga-bsc__pasos" aria-label="Pasos de la carga">
          <li *ngFor="let p of pasos"
              [class.is-hecho]="paso > p.numero || (p.numero === 3 && !!resultado)"
              [class.is-actual]="paso === p.numero && !(p.numero === 3 && !!resultado)"
              [attr.aria-current]="paso === p.numero ? 'step' : null">
            <span class="carga-bsc__paso-num" aria-hidden="true">
              <span class="material-icons" *ngIf="paso > p.numero || (p.numero === 3 && !!resultado); else numero">check</span>
              <ng-template #numero>{{ p.numero }}</ng-template>
            </span>
            {{ p.texto }}
          </li>
        </ol>
      </div>
    </section>

    <!-- El mismo input para elegir y para cambiar de archivo. -->
    <input #archivoInput type="file" hidden accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
           aria-label="Elegir archivo" (change)="eligeArchivo($event)" [disabled]="ocupado" />

    <output class="bsc-franja" *ngIf="sinHojaCarga">
      <span class="material-icons" aria-hidden="true">lock</span>
      <span>Tu perfil no tiene la hoja «Cargar Excel FOR-011»: el servidor no va a leer el archivo. Pide el perfil BSC de Calidad.</span>
    </output>

    <!-- ============================ 1 · Subir archivo ============================ -->
    <section class="table-page__card bsc-bloque" *ngIf="paso === 1" aria-labelledby="carga-bsc-subir">
      <header class="bsc-bloque__encabezado">
        <h2 id="carga-bsc-subir" tabindex="-1">Subir archivo</h2>
        <p>
          El FOR-011 de un área tal cual se llena: se lee la hoja «BSC» desde el encabezado «KPI´s», el área de la celda
          «Área:», el año de «Objetivos AAAA» y el corte de «Mes:». Las hojas ocultas se ignoran.
        </p>
      </header>

      <div class="carga-bsc__zona" [class.is-arrastrando]="arrastrando" [class.is-elegido]="!!archivo"
           (dragover)="alArrastrar($event)" (dragleave)="arrastrando = false" (drop)="alSoltar($event)">
        <span class="material-icons carga-bsc__zona-icono" aria-hidden="true">{{ archivo ? "description" : "upload_file" }}</span>
        <div class="carga-bsc__zona-texto">
          <ng-container *ngIf="!archivo">
            <strong>Arrastra aquí el FOR-011 o elígelo</strong>
            <span>Solo libros .xlsx, hasta {{ topeMb }} MB.</span>
          </ng-container>
          <ng-container *ngIf="archivo">
            <strong class="carga-bsc__nombre-archivo">{{ archivo.name }}</strong>
            <span>{{ tamano(archivo.size) }}</span>
          </ng-container>
        </div>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                [disabled]="ocupado" (click)="archivoInput.click()">
          <span class="material-icons" aria-hidden="true">folder_open</span>
          {{ archivo ? "Cambiar archivo" : "Elegir archivo" }}
        </button>
      </div>

      <div class="bsc-bloque__grid">
        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Modo de carga</mat-label>
          <mat-select [(ngModel)]="forma.modo" required [disabled]="ocupado">
            <mat-option *ngFor="let m of modos" [value]="m.valor" [disabled]="!!m.inhabilitado">{{ m.texto }}</mat-option>
          </mat-select>
          <mat-hint>{{ ayudaModo }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Año</mat-label>
          <mat-select [ngModel]="forma.anio ?? delLibro" (ngModelChange)="forma.anio = $event || null" [disabled]="ocupado">
            <mat-option [value]="delLibro">El del libro</mat-option>
            <mat-option *ngFor="let a of aniosOpciones" [value]="a">{{ a }}</mat-option>
          </mat-select>
          <mat-hint>Opcional: si el libro no lo trae o para comprobar que es el que esperas.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="!esPlaneacion">
          <mat-label>Cargar hasta</mat-label>
          <mat-select [ngModel]="forma.hastaTrimestre ?? delLibro" (ngModelChange)="forma.hastaTrimestre = $event || null"
                      [disabled]="ocupado">
            <mat-option [value]="delLibro">El que detecte el libro</mat-option>
            <mat-option *ngFor="let q of trimestres" [value]="q">Q{{ q }}</mat-option>
          </mat-select>
          <mat-hint>Por omisión, el último trimestre con avance real (o el de la celda «Mes:»).</mat-hint>
        </mat-form-field>
      </div>

      <div class="carga-bsc__error" *ngIf="errorPrevia" role="alert">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <div>
          <strong>No se pudo revisar el archivo</strong>
          <p>{{ errorPrevia }}</p>
        </div>
      </div>

      <div class="carga-bsc__acciones">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" [disabled]="!puedeRevisar"
                (click)="revisar()">
          <span class="material-icons" aria-hidden="true">{{ leyendo ? "hourglass_top" : "fact_check" }}</span>
          {{ leyendo ? "Leyendo el archivo…" : "Revisar archivo" }}
        </button>
      </div>
    </section>

    <!-- ============================ 2 · Revisar ============================ -->
    <ng-container *ngIf="paso === 2 && plan">
      <section class="table-page__card bsc-bloque" aria-labelledby="carga-bsc-detectado">
        <header class="bsc-bloque__encabezado bsc-bloque__encabezado--acciones">
          <div>
            <h2 id="carga-bsc-detectado" tabindex="-1">Lo que detectó el sistema</h2>
            <p>Cambiar el modo, el área, el año, el corte o la hoja vuelve a leer el archivo con esa elección.</p>
          </div>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  [disabled]="ocupado" (click)="archivoInput.click()">
            <span class="material-icons" aria-hidden="true">folder_open</span>
            Cambiar archivo
          </button>
        </header>

        <output class="carga-bsc__leyendo" *ngIf="leyendo">
          <span class="material-icons" aria-hidden="true">hourglass_top</span>
          Leyendo otra vez el archivo…
        </output>

        <div class="carga-bsc__detectado">
          <div class="carga-bsc__dato carga-bsc__dato--ancho">
            <span class="carga-bsc__dato-et">Archivo</span>
            <strong class="carga-bsc__nombre-archivo" [title]="archivo?.name">{{ archivo?.name }}</strong>
            <span class="carga-bsc__dato-sub">{{ detectadoArchivo }}</span>
          </div>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Modo de carga</mat-label>
            <mat-select [ngModel]="forma.modo" (ngModelChange)="cambiaModo($event)" [disabled]="ocupado">
              <mat-option *ngFor="let m of modos" [value]="m.valor" [disabled]="!!m.inhabilitado">{{ m.texto }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="eligeArea">
            <mat-label>Área</mat-label>
            <mat-select [ngModel]="forma.idBscArea" (ngModelChange)="cambiaArea($event)" [disabled]="ocupado"
                        placeholder="Elige el área">
              <mat-option [value]="null">Sin elegir (según la celda)</mat-option>
              <mat-option *ngFor="let a of areasParaElegir" [value]="a.idBscArea">
                {{ a.nombre }}{{ esSugerida(a) ? " · sugerida" : "" }}
              </mat-option>
            </mat-select>
            <mat-hint>
              La celda «Área:» dice «{{ plan.areaExcel || "nada" }}», que no es un nombre ni un alias de Parámetros.
            </mat-hint>
          </mat-form-field>

          <div class="carga-bsc__dato" *ngIf="!eligeArea">
            <span class="carga-bsc__dato-et">Área (celda «Área:»)</span>
            <strong>{{ nombreArea(plan) }}</strong>
            <span class="carga-bsc__dato-sub" *ngIf="plan.areaExcel">La celda dice «{{ plan.areaExcel }}»</span>
          </div>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Año («Objetivos AAAA»)</mat-label>
            <mat-select [ngModel]="forma.anio ?? delLibro" (ngModelChange)="cambiaAnio($event || null)" [disabled]="ocupado">
              <mat-option [value]="delLibro">El del libro{{ plan.anio && forma.anio == null ? " (" + plan.anio + ")" : "" }}</mat-option>
              <mat-option *ngFor="let a of aniosOpciones" [value]="a">{{ a }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="!esPlaneacion">
            <mat-label>Cargar hasta</mat-label>
            <mat-select [ngModel]="forma.hastaTrimestre ?? delLibro" (ngModelChange)="cambiaCorte($event || null)"
                        [disabled]="ocupado">
              <mat-option [value]="delLibro">El que detecte el libro{{ plan.hastaTrimestre && forma.hastaTrimestre == null ? " (Q" + plan.hastaTrimestre + ")" : "" }}</mat-option>
              <mat-option *ngFor="let q of trimestres" [value]="q">Q{{ q }}</mat-option>
            </mat-select>
            <mat-hint>Celda «Mes:»: {{ detectadoCorte }}</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic"
                          *ngIf="hojasParaElegir.length > 0">
            <mat-label>Hoja</mat-label>
            <mat-select [ngModel]="forma.hoja" (ngModelChange)="cambiaHoja($event)" [disabled]="ocupado">
              <mat-option [value]="null">Elige la hoja…</mat-option>
              <mat-option *ngFor="let h of hojasParaElegir" [value]="h">{{ h }}</mat-option>
            </mat-select>
            <mat-hint>Las hojas visibles del libro; cambiarla vuelve a leer el archivo.</mat-hint>
          </mat-form-field>

          <div class="carga-bsc__dato">
            <span class="carga-bsc__dato-et">KPIs leídos</span>
            <strong>{{ detectadoKpis }}</strong>
          </div>

          <div class="carga-bsc__dato">
            <span class="carga-bsc__dato-et">{{ plan.modo === "PLANEACION" || plan.modo === "AVANCES" ? "Avances" : "Con datos" }}</span>
            <strong>{{ detectadoConDatos }}</strong>
          </div>
        </div>

        <div class="carga-bsc__trimestres" *ngIf="planeacionAlConfirmar as p">
          <span class="carga-bsc__dato-et">Al confirmar</span>
          <span class="table-page__status-badge" [ngClass]="p.estado.clase">
            <span class="material-icons" aria-hidden="true">{{ p.estado.icono }}</span>
            {{ p.estado.texto }}
          </span>
          <span class="carga-bsc__dato-sub">{{ p.texto }}</span>
        </div>

        <div class="carga-bsc__trimestres" *ngIf="trimestresAlConfirmar.length > 0">
          <span class="carga-bsc__dato-et">Al confirmar</span>
          <span class="table-page__status-badge" *ngFor="let t of trimestresAlConfirmar" [ngClass]="t.estado.clase">
            <span class="material-icons" aria-hidden="true">{{ t.estado.icono }}</span>
            Q{{ t.q }} {{ t.estado.texto.toLowerCase() }}<ng-container *ngIf="t.nota"> · {{ t.nota }}</ng-container>
          </span>
          <span class="carga-bsc__dato-sub" *ngIf="plan.modo === 'AVANCES'">
            La planeación y sus trimestres no cambian de estatus: el envío a revisión se hace después.
          </span>
        </div>
      </section>

      <!-- Errores (impiden confirmar) y avisos (se miran y se puede cargar). -->
      <section class="table-page__card bsc-bloque" *ngIf="errores.length > 0 || avisos.length > 0">
        <div class="carga-bsc__mensajes carga-bsc__mensajes--error" *ngIf="errores.length > 0" role="alert">
          <h3>
            <span class="material-icons" aria-hidden="true">block</span>
            Lo que impide confirmar ({{ errores.length }})
          </h3>
          <ul>
            <li *ngFor="let e of errores; trackBy: trackMensaje" [attr.title]="e.codigo || null">{{ e.texto }}</li>
          </ul>
        </div>
        <div class="carga-bsc__mensajes carga-bsc__mensajes--aviso" *ngIf="avisos.length > 0">
          <h3>
            <span class="material-icons" aria-hidden="true">warning_amber</span>
            Para revisar ({{ avisos.length }}) · no impiden cargar
          </h3>
          <ul>
            <li *ngFor="let a of avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
          </ul>
        </div>
      </section>

      <!-- ============================ El plan ============================ -->
      <section class="table-page__card bsc-bloque" aria-labelledby="carga-bsc-plan">
        <header class="bsc-bloque__encabezado">
          <h2 id="carga-bsc-plan">Plan de carga</h2>
          <p *ngIf="plan.modo !== 'PLANEACION' && plan.modo !== 'AVANCES'">
            Un renglón por KPI del FOR-011, emparejado con el maestro de KPIs del área. Real, programado y peso en %;
            el ponderado y los acumulados los recalcula el sistema.
          </p>
          <p *ngIf="plan.modo === 'AVANCES'">
            Un renglón por KPI del FOR-011, emparejado con los KPI de la planeación {{ plan.anio }} autorizada. Real,
            programado y peso en %, como quedan: lo capturado con lo del libro encima; el trimestre enviado o autorizado
            conserva lo guardado. Meta y pesos son los autorizados.
          </p>
          <p *ngIf="plan.modo === 'PLANEACION'">
            Un renglón por KPI del FOR-011, emparejado con el maestro de KPIs del área y comparado con la planeación
            {{ plan.anioOrigen ?? "anterior" }}. Meta y peso de cada trimestre en %; NA donde no aplica.
          </p>
        </header>

        <div class="table-page__table-wrap carga-bsc__tabla-wrap" *ngIf="filas.length > 0; else sinFilas">
          <table class="table-page__table carga-bsc__tabla">
            <thead>
              <tr>
                <th class="carga-bsc__col-casilla">
                  <mat-checkbox [checked]="todasMarcadas" [indeterminate]="algunaMarcada && !todasMarcadas"
                                [disabled]="ocupado || ningunaCargable" (change)="marcaTodas($event.checked)"
                                aria-label="Cargar todos los KPI"></mat-checkbox>
                </th>
                <th>KPI leído del Excel</th>
                <th class="carga-bsc__num">Meta</th>
                <th class="carga-bsc__num" *ngFor="let q of columnasQ">
                  Q{{ q }}<span class="carga-bsc__th-sub">real · prog · peso</span>
                </th>
                <th class="carga-bsc__num" *ngIf="columnasPeso.length > 0">
                  Pesos<span class="carga-bsc__th-sub">{{ columnasPeso.length === 1 ? "Q" + columnasPeso[0] : "Q" + columnasPeso.join(" · Q") }}</span>
                </th>
                <th>Qué hará el sistema</th>
                <th>Avisos</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of filas; trackBy: trackFila" [attr.data-fila]="v.filaExcel"
                  [class.is-error]="v.conError"
                  [class.is-aviso]="!v.conError && v.avisos.length > 0"
                  [class.is-desmarcada]="!marcadas.has(v.filaExcel)">
                <td class="carga-bsc__col-casilla">
                  <mat-checkbox [checked]="marcadas.has(v.filaExcel)" [disabled]="ocupado || !v.cargable"
                                (change)="marcaFila(v.filaExcel, $event.checked)"
                                [aria-label]="v.etiquetaCasilla"></mat-checkbox>
                </td>
                <td class="carga-bsc__col-objetivo">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ v.objetivo }}</strong>
                    <span class="table-page__subtext" *ngIf="v.indicador">{{ v.indicador }}</span>
                    <span class="table-page__subtext">Fila {{ v.filaExcel }}</span>
                  </div>
                </td>
                <td class="carga-bsc__num">
                  <div class="table-page__cell-stack">
                    <span class="table-page__text">{{ v.meta }}</span>
                    <span class="table-page__subtext" *ngIf="v.metaNota">{{ v.metaNota }}</span>
                  </div>
                </td>
                <td class="carga-bsc__num" *ngFor="let c of v.trimestres" [class.is-na]="c.na" [class.is-conservado]="c.conservado">
                  {{ c.texto }}<span class="table-page__subtext carga-bsc__celda-nota" *ngIf="c.conservado">se conserva</span>
                </td>
                <td class="carga-bsc__num" *ngIf="columnasPeso.length > 0">{{ v.pesosDespues }}</td>
                <td class="carga-bsc__col-accion">
                  <div class="table-page__cell-stack">
                    <span class="table-page__status-badge" [ngClass]="v.accionClase">{{ v.accionTexto }}</span>
                    <span class="table-page__subtext" *ngIf="v.maestro">{{ v.maestro }}</span>
                    <span class="table-page__subtext" *ngIf="v.nota">{{ v.nota }}</span>
                    <button type="button" class="carga-bsc__enlace" *ngIf="v.sugerido" [disabled]="ocupado"
                            (click)="confirmaSugerido(v)"
                            [attr.aria-label]="v.etiquetaConfirmar">
                      <span class="material-icons" aria-hidden="true">link</span>
                      Es el mismo KPI
                    </button>
                    <button type="button" class="carga-bsc__enlace" *ngIf="v.asignada" [disabled]="ocupado"
                            (click)="quitaAsignacion(v)"
                            [attr.aria-label]="v.etiquetaDeshacer">
                      <span class="material-icons" aria-hidden="true">link_off</span>
                      Deshacer
                    </button>
                  </div>
                </td>
                <td class="carga-bsc__col-avisos">
                  <ul class="carga-bsc__avisos-fila" *ngIf="v.avisos.length > 0; else sinAvisos">
                    <li *ngFor="let a of v.avisos; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
                  </ul>
                  <ng-template #sinAvisos><span class="table-page__subtext">—</span></ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinFilas>
          <div class="table-page__empty carga-bsc__vacio">
            <span class="material-icons" aria-hidden="true">table_rows</span>
            <h3>No se leyó ningún KPI</h3>
            <p>Revisa lo que impide confirmar: el libro no trae la tabla del FOR-011 o no se pudo leer.</p>
          </div>
        </ng-template>

        <p class="bsc-nota carga-bsc__nota" *ngIf="plan.modo !== 'PLANEACION' && plan.modo !== 'AVANCES'">
          También se cargan los textos de los meses hasta el corte (actividad y evidencia), los recursos, la descripción,
          los beneficios y los comentarios.
        </p>
        <p class="bsc-nota carga-bsc__nota" *ngIf="plan.modo === 'AVANCES'">
          En avances se cargan, hasta el corte y solo en los trimestres que no están enviados ni autorizados, el real, el
          programado, los recursos y los textos de los meses (actividad y evidencia); una celda vacía conserva lo
          capturado. La meta, la unidad, los pesos, los NA, la descripción, los beneficios y los comentarios se quedan como
          se autorizaron, y un KPI que no está en la planeación no se carga.
        </p>
        <p class="bsc-nota carga-bsc__nota" *ngIf="plan.modo === 'PLANEACION'">
          En planeación se cargan la meta, la unidad, los pesos, los NA, la descripción, los beneficios y los comentarios;
          los avances, el programado y los textos de los meses del libro no se cargan. El motivo de cada cambio de meta se
          escribe después en Planeación.
        </p>

        <footer class="carga-bsc__pie">
          <span>
            Al confirmar, el servidor vuelve a leer el archivo tal como se revisó aquí; si
            {{ plan.modo === "AVANCES" ? "un trimestre se envió o la planeación cambió" : "el maestro de KPIs o los parámetros cambiaron" }}
            desde esta vista previa, la carga se rechaza y no se guarda nada. Si corriges el Excel, vuelve a elegirlo con
            «Cambiar archivo».
          </span>
          <div class="carga-bsc__pie-acciones">
            <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                    [disabled]="cargando" (click)="reiniciar()">
              <span class="material-icons" aria-hidden="true">close</span>
              Cancelar
            </button>
            <button type="button" id="carga-bsc-confirmar" mat-raised-button class="btn table-page__primary-btn"
                    [disabled]="!puedeConfirmar" (click)="confirmar()">
              <span class="material-icons" aria-hidden="true">{{ cargando ? "hourglass_top" : "cloud_upload" }}</span>
              {{ textoConfirmar }}
            </button>
          </div>
        </footer>
      </section>
    </ng-container>

    <!-- ============================ 3 · Resultado ============================ -->
    <section class="table-page__card bsc-bloque" *ngIf="paso === 3 && resultado && resumen"
             aria-labelledby="carga-bsc-resultado">
      <header class="bsc-bloque__encabezado carga-bsc__resultado-cab">
        <span class="material-icons carga-bsc__resultado-icono" aria-hidden="true">task_alt</span>
        <div>
          <h2 id="carga-bsc-resultado" tabindex="-1">Carga aplicada</h2>
          <p>{{ textoResultado }}</p>
        </div>
      </header>

      <dl class="bsc-datos">
        <div>
          <dt>Planeación del año</dt>
          <dd *ngIf="resultado.modo !== 'PLANEACION' && resultado.modo !== 'AVANCES'">Autorizada por la carga<span class="carga-bsc__dd-sub" *ngIf="resultado.idEjercicio">· ejercicio {{ resultado.idEjercicio }}</span></dd>
          <dd *ngIf="resultado.modo === 'AVANCES'">Autorizada, sin cambios<span class="carga-bsc__dd-sub" *ngIf="resultado.idEjercicio">· ejercicio {{ resultado.idEjercicio }}</span></dd>
          <dd *ngIf="resultado.modo === 'PLANEACION'">
            <span class="table-page__status-badge" [ngClass]="estadoResultado.clase">
              <span class="material-icons" aria-hidden="true">{{ estadoResultado.icono }}</span>
              {{ estadoResultado.texto }}
            </span>
            <span class="carga-bsc__dd-sub" *ngIf="resultado.idEjercicio">· ejercicio {{ resultado.idEjercicio }}</span>
          </dd>
        </div>
        <div>
          <dt>KPIs cargados</dt>
          <dd *ngIf="resultado.modo !== 'AVANCES'">
            {{ resumen.cargados }}
            <span class="carga-bsc__dd-sub">
              · {{ resumen.creados }} {{ resumen.creados === 1 ? "nuevo" : "nuevos" }} en el maestro ·
              {{ resumen.actualizados }} {{ resumen.actualizados === 1 ? "actualizado" : "actualizados" }} ·
              {{ resumen.iguales }} sin cambios
            </span>
          </dd>
          <dd *ngIf="resultado.modo === 'AVANCES'">
            {{ resumen.cargados }}
            <span class="carga-bsc__dd-sub">· sus avances; el maestro y las metas no cambian</span>
          </dd>
        </div>
        <div *ngIf="resumen.omitidos > 0">
          <dt>No se cargaron</dt>
          <dd>
            {{ resumen.omitidos }}
            <span class="carga-bsc__dd-sub">
              · {{ resultado.modo === "AVANCES" ? "desmarcados o fuera de la planeación autorizada" : "desmarcados en la vista previa" }}
            </span>
          </dd>
        </div>
        <div *ngIf="resultado.idImportacion">
          <dt>Constancia</dt>
          <dd>Carga {{ resultado.idImportacion }}<span class="carga-bsc__dd-sub">· {{ archivo?.name }}</span></dd>
        </div>
      </dl>

      <div class="carga-bsc__trimestres" *ngIf="trimestresResultado.length > 0">
        <span class="carga-bsc__dato-et">Trimestres</span>
        <span class="table-page__status-badge" *ngFor="let t of trimestresResultado" [ngClass]="t.estado.clase">
          <span class="material-icons" aria-hidden="true">{{ t.estado.icono }}</span>
          Q{{ t.q }} {{ t.estado.texto.toLowerCase() }}<ng-container *ngIf="t.nota"> · {{ t.nota }}</ng-container>
        </span>
      </div>
      <p class="bsc-nota carga-bsc__nota" *ngIf="cierreResultado as c">
        Q{{ c.q }} sigue {{ c.q === trimestreEnCaptura ? "en captura" : "regresado" }}: «{{ c.texto }}» abre el cierre, que
        revisa lo que falte (meses, avance real, fechas) antes de enviarlo a Dirección. Si hay que corregir algo del
        Excel, se vuelve a cargar aquí mientras no se envíe.
      </p>
      <p class="bsc-nota carga-bsc__nota" *ngIf="!cierreResultado && trimestreEnCaptura && resultado.modo !== 'AVANCES'">
        Q{{ trimestreEnCaptura }} queda en captura: se completa y se envía a revisión desde el BSC del área.
      </p>
      <p class="bsc-nota carga-bsc__nota" *ngIf="resultado.modo === 'PLANEACION'">
        La planeación no se autoriza con la carga: en Planeación se revisa, se escriben los motivos de los cambios de meta
        y se envía a autorización.
      </p>

      <div class="carga-bsc__mensajes carga-bsc__mensajes--aviso" *ngIf="avisosResultado.length > 0">
        <h3>
          <span class="material-icons" aria-hidden="true">warning_amber</span>
          Avisos de la carga ({{ avisosResultado.length }})
        </h3>
        <ul>
          <li *ngFor="let a of avisosResultado; trackBy: trackMensaje" [attr.title]="a.codigo || null">{{ a.texto }}</li>
        </ul>
      </div>

      <footer class="carga-bsc__pie carga-bsc__pie--fin">
        <div class="carga-bsc__pie-acciones">
          <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
             *ngIf="resultado.modo === 'PLANEACION'" [routerLink]="rutaPlaneacion" [queryParams]="queryPlaneacion">
            <span class="material-icons" aria-hidden="true">edit_note</span>
            Ir a Planeación
          </a>
          <!-- F6.7: las dos vías terminan en el mismo cierre (C3 → cerrar.do). -->
          <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" id="carga-bsc-cierre"
             *ngIf="cierreResultado as c" [routerLink]="c.ruta">
            <span class="material-icons" aria-hidden="true">task_alt</span>
            {{ c.texto }}
          </a>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="reiniciar()">
            <span class="material-icons" aria-hidden="true">upload_file</span>
            Cargar otro archivo
          </button>
        </div>
      </footer>
    </section>
  </div>
</div>
